export type AccentKey = "purple" | "blue" | "emerald" | "rose" | "amber" | "midnight";

export interface AccentDef {
  key: AccentKey;
  labelKey: string;
  swatch: string;
}

export const ACCENTS: AccentDef[] = [
  { key: "purple", labelKey: "theme.purple", swatch: "#6c4cf6" },
  { key: "blue", labelKey: "theme.blue", swatch: "#4d8df7" },
  { key: "emerald", labelKey: "theme.emerald", swatch: "#2fa874" },
  { key: "rose", labelKey: "theme.rose", swatch: "#f0567e" },
  { key: "amber", labelKey: "theme.amber", swatch: "#e8960f" },
  { key: "midnight", labelKey: "theme.midnight", swatch: "#3f3a6e" }
];

const STORAGE_KEY = "nelurio.accent";

export function readAccent(): AccentKey {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY) as AccentKey | null;
    if (value && ACCENTS.some((accent) => accent.key === value)) return value;
  } catch { /* ignore */ }
  return "purple";
}

export function storeAccent(key: AccentKey) {
  try { window.localStorage.setItem(STORAGE_KEY, key); } catch { /* ignore */ }
}

/** Applies the palette to :root so every component in both layers syncs. */
export function applyAccent(key: AccentKey) {
  const root = document.documentElement;
  root.dataset.accent = key;
  const palettes: Record<AccentKey, [string, string, string, string, string]> = {
    //        purple      purple-deep  lilac       grad-a      grad-b
    purple:   ["#6c4cf6", "#5134cc", "#eeeafe", "#8b6cff", "#5a34e7"],
    blue:     ["#4d8df7", "#2563c9", "#e3eeff", "#6da3ff", "#2f6fd6"],
    emerald:  ["#2fa874", "#1d7a54", "#e0f5ea", "#52c08d", "#1e8a5e"],
    rose:     ["#f0567e", "#c93459", "#ffe9f0", "#ff7fa0", "#d84068"],
    amber:    ["#e8960f", "#b87408", "#fdf1d7", "#f6b03c", "#c67c0a"],
    midnight: ["#5b54c8", "#3d3894", "#e9e8fb", "#7d75e8", "#453fa6"]
  };
  const [purple, deep, lilac, gradA, gradB] = palettes[key];
  root.style.setProperty("--nl-purple", purple);
  root.style.setProperty("--nl-purple-deep", deep);
  root.style.setProperty("--nl-lilac", lilac);
  root.style.setProperty("--nl-grad-a", gradA);
  root.style.setProperty("--nl-grad-b", gradB);
  root.style.setProperty("--nl-focus", `0 0 0 4px color-mix(in srgb, ${purple} 22%, transparent)`);
  root.style.setProperty("--nl-shadow-floating", `0 24px 60px color-mix(in srgb, ${deep} 24%, transparent)`);
}
